/** A resource operation category evaluated by resource managers (port of C# `ActionType`). */
export enum ActionType {
  Attach = 0,
  Delete = 1,
  Execute = 2,
  GetProperty = 3,
  SetProperty = 4,
  CreateResource = 5,
  UpdateAttributes = 6,
  InquireAttributes = 7,
  AddParent = 8,
  RemoveParent = 9,
  AddChild = 10,
  RemoveChild = 11,
  Rename = 12,
  ReceiveEvent = 13,
  ViewTypeDef = 14,
  Detach = 15,
  Subscribe = 16,
  Unsubscribe = 17,
  PullStream = 18,
  TerminateExecution = 19,
  HaltExecution = 20,
  ResumeExecution = 21,
}
